import { useCallback } from 'react';
import styled from 'styled-components';
import { Button, Typography } from '@elfsight/widget-ui';
import { getInvertedColor } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { EmailSubmitPopup } from '../components/email-submit-popup/email-submit-popup';
import { useEmailSubmitPopup } from '../use-email-submit-popup';

export function CTA({ isMobile }: { isMobile?: boolean }) {
  const {
    resultCTAHeading,
    resultCTACaption,
    resultButtonText,
    resultButtonLink,
    actionButtonColor,
    editMode,
    resultButtonAction
  } = useSettings();

  const { isFormPopupOpen, openFormPopup, closeFormPopup } =
    useEmailSubmitPopup();

  const handleClick = useCallback(() => {
    if (resultButtonAction === 'openForm') {
      openFormPopup();

      return;
    }

    const { rawValue = '', target } = resultButtonLink ?? {};
    const linkURL = rawValue.trim();

    if (linkURL) {
      window.open(linkURL, editMode ? '_blank' : target);
    }
  }, [editMode, resultButtonLink, resultButtonAction, openFormPopup]);

  const showCTA =
    resultButtonAction !== 'noAction' &&
    (resultCTAHeading || resultCTACaption || resultButtonText);

  if (!showCTA) {
    return null;
  }

  return (
    <Container>
      {resultCTAHeading && (
        <Typography
          lineHeight="28px"
          textStyle={{ fontSize: isMobile ? 22 : 24, fontWeight: 'bold' }}
        >
          {resultCTAHeading}
        </Typography>
      )}

      {resultCTACaption && (
        <Typography
          lineHeight="20px"
          textStyle={{ fontSize: 15 }}
          dangerouslySetInnerHTML={{ __html: resultCTACaption }}
        />
      )}

      {resultButtonText && (
        <Button
          aria-label={resultButtonText}
          color={actionButtonColor}
          fontColor={getInvertedColor(actionButtonColor)}
          onClick={handleClick}
          font={{ fontSize: 15, fontWeight: 'bold' }}
          style={{
            marginTop: resultCTAHeading || resultCTACaption ? 8 : undefined
          }}
          fullWidth
        >
          {resultButtonText}
        </Button>
      )}

      <EmailSubmitPopup
        show={isFormPopupOpen}
        onCloseRequest={closeFormPopup}
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 24px;
`;
